export default {"src":"/_next/static/media/tracker.ce824fb8.svg","height":18,"width":17,"blurWidth":0,"blurHeight":0};